import React from 'react';
import { Formik, Field, Form } from 'formik';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { VaultClearButton } from 'components/Common/MUIStyledComponents';
import { NextButton } from 'components/Common/MUIStyledComponents';
interface ICaseFilterProps {
  handleSubmit: any;
};

const CaseFilter: React.FC<ICaseFilterProps> = (props: ICaseFilterProps) => {
  const { handleSubmit } = props;

  return (
    <>
      <Formik
        initialValues={{
          docType: '',
          date: '',
          searchVal: '',
        }}
        onSubmit={handleSubmit}
      >
        {({ values, submitForm, resetForm }) =>
          <Form onChange={() => {
            submitForm();
          }}>
            <div className='vault-filter-opts-container'>

              <div className='vault-filter-div'>
                <p>Filters</p>
                <VaultClearButton onClick={() => resetForm()} >
                  Clear All
                  <div className='vault-svg-spacer'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                      <path d='M11.25 5.13281C11.25 5.13281 12.1064 4.71094 9 4.71094C7.88748 4.71094 6.79995 5.04084 5.87492 5.65892C4.94989 6.277 4.22892 7.15551 3.80318 8.18334C3.37744 9.21118 3.26604 10.3422 3.48309 11.4333C3.70013 12.5245 4.23586 13.5267 5.02253 14.3134C5.8092 15.1001 6.81148 15.6358 7.90262 15.8529C8.99376 16.0699 10.1248 15.9585 11.1526 15.5328C12.1804 15.107 13.0589 14.386 13.677 13.461C14.2951 12.536 14.625 11.4485 14.625 10.3359' stroke='#F5FAFF' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
                      <path d='M9 2.03906L11.8125 4.85156L9 7.66406' stroke='#F5FAFF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </VaultClearButton>
              </div>
              <div className='vault-filter-div'>
                <Field
                  name='docType'
                  as='select'
                  className='vault-filter-input'
                  value={values.docType}
                >
                  <option value='' label='Document Type'></option>
                  <option value='report'>Analytical Report</option>
                  <option value='riskScore'>Risk Score</option>
                  <option value='bulkScore'>Bulk Score</option>
                  <option value='dailyReport'>Daily Report</option>
                </Field>
                <Field
                  name='date'
                  label='Select Dates'
                  type='date'
                  className='vault-filter-input'
                  value={values.date}
                />
                <div className='vault-create-btn-spacer'>
                  <div className='vault-create-btn'>
                    <Link to='/analytics-vault/case'>
                      <VaultClearButton>
                        <AddIcon fontSize='small' />
                        Create New Case
                      </VaultClearButton>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='header-search-div'>
                <div className='vault-input-spacer'>
                  <Field className='vault-search-input' placeholder='Search here...' name='searchVal' value={values.searchVal}></Field>
                </div>
                <NextButton onClick={() => {
                  submitForm();
                }}>
                        Search
                </NextButton>
              </div>
            </div>
          </Form>
        }
      </Formik>
    </>
  );
};

export default CaseFilter;
